"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
owa_bundling_1.preloadScriptChunk('ContactPickerPane');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "ContactPickerPane" */ './lazyIndex');
});
// Delayed Loaded Components
exports.ContactPickerPane = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.ContactPickerPane; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-contact-picker/lib/index.js
// module id = 3185
// module chunks = 2 3